export const HERO_CONFIG = {
  autoplayDuration: 5000,
  headerScrollThreshold: 80,
  logo: {
    src: "/qualitycollectionlogo.png", // public/logo.png
    alt: "Queens Craft",
  },
} as const;